export const BASE_URL = process.env.REACT_APP_BASE_PATH

//project constants
export const statuses = {
  accepted: {
    value: 'accepted',
    text: 'Принята',
  },
  declined: {
    value: 'declined',
    text: 'Отклонена',
  },
  pending: {
    value: 'pending',
    text: 'На рассмотрении',
  },
}

export const ROLE_ADMIN = 'ROLE_ADMIN'
export const ROLE_USER = 'ROLE_USER'
export const ROLE_ORGANIZER = 'ROLE_ORGANIZER'
export const ROLE_COACH = 'ROLE_COACH'
export const ROLE_SPORTSMAN = 'ROLE_SPORTSMAN'

export const userRoles = {
  ROLE_ADMIN: {
    value: ROLE_ADMIN,
    text: 'Администратор',
    textEN: 'admin',
  },
  ROLE_COACH: {
    value: ROLE_COACH,
    text: 'Тренер',
    textEN: 'coach',
  },
  ROLE_ORGANIZER: {
    value: ROLE_ORGANIZER,
    text: 'Организатор',
    textEN: 'organizer',
  },
  ROLE_SPORTSMAN: {
    value: ROLE_SPORTSMAN,
    text: 'Спортсмен',
    textEN: 'sportsman',
  },
}

export const genders = {
  male: {
    value: 'male',
    text: 'Мужской',
  },
  female: {
    value: 'female',
    text: 'Женский',
  },
}

export const sportKinds = {
  fight: {
    value: 'fight',
    text: 'Единоборства',
  },
  gym: {
    value: 'gym',
    text: 'Гимнастика',
  },
  tennis: {
    value: 'tennis',
    text: 'Теннис',
  },
}

export const weightStatuses = {
  pending: {
    value: 'pending',
    text: 'Неизвестен',
  },
  accepted: {
    value: 'accepted',
    text: 'Допуск',
  },
  declined: {
    value: 'declined',
    text: 'Недопуск',
  },
}

export const matchStatuses = {
  finished: {
    value: 'finished',
    text: 'Закончен',
  },
  paused: {
    value: 'paused',
    text: 'Пауза',
  },
  pending: {
    value: 'pending',
    text: 'Ожидается',
  },
}

export const textRegEx = /\s+/gm

export const MAX_FILE_COUNT = 10
export const MAX_FILE_SIZE = 50
export const EMPTY_SPACE = '\u00A0'

//errors
export const INVALID_PHONE = 'Номер введен неверно'
